import { createContext, useContext, useMemo, type ReactNode } from 'react';

import { useAppSelector } from '../../redux/ReduxHooks';
import { buildRegisteredCustomCallableParametersFromCode } from '../../utils/pythonSourceScanUtils';

const CustomCallableStreamsContext = createContext<ReadonlySet<string> | null>(null);

/** Shares `register_callable` stream parameters parsed from project code across dashboard widgets and toolbar. */
export function CustomCallableStreamsProvider({ children }: { children: ReactNode }) {
  const projectCode = useAppSelector((state) => state.project.loadedProject?.program?.code ?? '');
  const registeredParameters = useMemo(() => buildRegisteredCustomCallableParametersFromCode(projectCode), [projectCode]);

  return <CustomCallableStreamsContext.Provider value={registeredParameters}>{children}</CustomCallableStreamsContext.Provider>;
}

export function useRegisteredCustomCallableParameters(): ReadonlySet<string> {
  const registeredParameters = useContext(CustomCallableStreamsContext);
  if (registeredParameters === null) {
    throw new Error('useRegisteredCustomCallableParameters must be used within CustomCallableStreamsProvider');
  }
  return registeredParameters;
}
